<template>
  <div class="companyList">
    <div class="mycompanytotal">共有{{ companyData.length }}家公司</div>
    <div style="margin-left: 0.2rem; display: inline-block">
      <i
        class="el-icon-circle-plus-outline"
        style="font-size: 0.43rem; cursor: pointer; vertical-align: middle"
        title="绑定公司"
        @click="that.openBind({ id: userId })"
      ></i>
    </div>
    <el-drawer
      title="公司信息"
      :visible.sync="companyInfoDrawer"
      direction="rtl"
      :append-to-body="true"
      :before-close="handleCompanyInfoBeforeClose"
      size="50%"
    >
      <div class="m-tabs-content" style="padding: 0px 0.2rem 0px 0.4rem">
        <el-row>
          <company-info :companyId="companyInfoId"></company-info>
        </el-row>
      </div>
    </el-drawer>
    <el-table
      :data="companyData"
      border
      style="width: 100%; margin-top: 0.4em"
      size="mini"
      max-height="550"
    >
      <el-table-column
        prop="company_name"
        label="公司名称"
        width="220"
        fixed="left"
      >
        <template slot-scope="scope">
          <div
            style="color: #409eff; font-weight: bold; cursor: pointer"
            @click="companyInfoDetail(scope.$index, companyData)"
          >
            {{ scope.row.company_name }}
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="date_of_set" label="注册时间" width="180">
      </el-table-column>
      <el-table-column prop="cre_code" label="统一社会信用代码" width="180">
      </el-table-column>
      <el-table-column prop="legaler" label="企业法人" width="110">
      </el-table-column>
      <el-table-column prop="regStatus" label="企业状态" width="100">
      </el-table-column>
      <el-table-column prop="business" label="所属业务" width="150">
      </el-table-column>
      <el-table-column prop="area.areaName" label="所属区域" width="160">
      </el-table-column>
      <el-table-column prop="areapark.areaName" label="所属园区" width="180">
      </el-table-column>
      <el-table-column fixed="right" label="操作" width="100">
        <template slot-scope="scope">
          <el-popconfirm title="确定解绑吗？" @onConfirm="confirm">
            <!-- <el-tooltip class="item" effect="dark" content="解绑" placement="top"> -->
            <el-button
              type="warning"
              slot="reference"
              @click="unBind(scope.row)"
              icon="el-icon-circle-close"
              size="mini"
              circle
              title="解绑"
              style="font-size: 0.28rem"
            ></el-button>
            <!-- </el-tooltip> -->
          </el-popconfirm>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>
<script>
import CompanyInfo from 'common/CompanyInfo'
export default {
  name: 'CompanyList',
  props: {
    userId: Number,
    that: Object
  },
  components: {
    CompanyInfo
  },
  data () {
    return {
      companyInfoDrawer: false,
      companyInfoId: null,
      companyData: [],
      unBindId: ''
    }
  },
  watch: {
    userId: function (val) {
      this.companyData = []
      if (val) {
        this.loadCompanyList(val)
      }
    }
  },
  methods: {
    loadCompanyList (val) {
      this.$axios
        .get('/api/customers/getcompanylist?id=' + val)
        .then(res => {
          if (res.data.code === 1) {
            var data = res.data.data.data[0].mycompany
            data.map(item => {
              if (res.data.data.data[0].business !== null) {
                item.business = res.data.data.data[0].business.username
              }
            })
            this.companyData = data
          }
        })
        .catch()
    },
    handleCompanyInfoBeforeClose (done) {
      this.companyInfoId = null
      done()
    },
    companyInfoDetail (row, data) {
      this.companyInfoDrawer = true
      setTimeout(() => {
        this.companyInfoId = data[row].id
      })
    },
    unBind (row) {
      this.unBindId = row.id
    },
    confirm () {
      this.$axios
        .put('api/customer/unbindcompany?company_id=' + this.unBindId)
        .then(res => {
          const { data } = res
          if (data.code === 1) {
            this.$message.success(data.msg)
            this.that.table = false
            this.that.companyInfos = null
            this.that.loadTable(this.that.npage)
            this.that.loadCount()
          }
        })
        .catch()
    }
  }
}
</script>
<style scoped>
.companyList {
  padding: 0.2rem;
  /* margin-left: 3.6rem;
    padding: 1.82rem 0.4rem 0.4rem 0.4rem; */
}
.mycompanytotal {
  margin-top: 0.4rem;
  display: inline-block;
}
</style>



// WEBPACK FOOTER //
// src/common/CompanyList.vue